export const Footer = () => (
  <footer className="site-footer" data-testid="site-footer">
    <div className="wrap">
      <div className="footer-brand">
        <span className="brand-name">Sorted</span>
        <span className="brand-tag">Launching in Malta</span>
      </div>
      <nav className="footer-links" data-testid="footer-links">
        <a href="#apply" data-testid="footer-apply-link">Founding tasker registration</a>
        <a href="mailto:info@sortedmalta.com" data-testid="footer-email-link">info@sortedmalta.com</a>
        <a href="mailto:info@sortedmalta.com?subject=Privacy" data-testid="footer-privacy-link">Privacy</a>
      </nav>
    </div>
  </footer>
);
